var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWithShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80C62.091 80 80 62.092 80 40C80 17.91 62.091 0 40 0C17.908 0 0 17.91 0 40C0 62.092 17.908 80 40 80Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 69C56.016 69 69 56.017 69 40C69 23.985 56.016 11 40 11C23.983 11 11 23.985 11 40C11 56.017 23.983 69 40 69Z",
    fill: "#EF4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.783 28.8787C30.9546 27.7071 32.854 27.7071 34.0256 28.8787L40.9043 35.7574L47.783 28.8787C48.9545 27.7071 50.854 27.7071 52.0256 28.8787C53.1972 30.0502 53.1972 31.9497 52.0256 33.1213L45.147 40L52.0256 46.8787C53.1972 48.0503 53.1972 49.9497 52.0256 51.1213C50.854 52.2929 48.9545 52.2929 47.783 51.1213L40.9043 44.2427L34.0256 51.1213C32.854 52.2929 30.9545 52.2929 29.783 51.1213C28.6114 49.9497 28.6114 48.0502 29.783 46.8787L36.6617 40L29.783 33.1213C28.6114 31.9497 28.6114 30.0503 29.783 28.8787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithShadow);
export default __webpack_public_path__ + "static/media/close-with-shadow.64d77c8817e025ad840fe32c59b8ecbe.svg";
export { ForwardRef as ReactComponent };